
import { Component, inject, OnInit } from '@angular/core';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { getCurrentLang } from 'src/helpers/get-current-lang';

import { languages } from '../../../helpers/constants';

@Component({
  selector: 'app-language-selector',
  imports: [MatSelectModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
})
export class LanguageSelectorComponent implements OnInit {
  languages = languages;
  selectedLanguage = this.languages[0].code;
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly translate = inject(TranslateService);

  ngOnInit() {
    this.selectedLanguage = getCurrentLang();
    this.translate.use(this.selectedLanguage);
  }

  onLanguageChange(event: MatSelectChange) {
    const selectedLang = event.value;

    this.translate.use(selectedLang);
    this.router.navigate([selectedLang, ...this.router.url.split('/').slice(2)]);
  }
}
